import HeroButtonGroup from '@/components/sections/builder/elements/body/hero/button-group';
import ElementContent from '@/components/sections/builder/elements/body/hero/content';
import ElementSetting from '@/components/sections/builder/elements/body/hero/setting';
import HeroSubtitle from '@/components/sections/builder/elements/body/hero/subtitle';
import HeroTitle from '@/components/sections/builder/elements/body/hero/title';
import { HeroElementDataType } from '@/components/sections/builder/elements/body/hero/types';
import { GalleryVertical } from 'lucide-react';

const defaultData: HeroElementDataType = {
  name: 'Hero',
  layout: 'full',
  contentAlign: 'left',
  imagePosition: 'right',
  mobileMinWidth: 720,
};

const ElementPreviewIcon = GalleryVertical;

const Hero = {
  type: 'hero',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [HeroTitle, HeroSubtitle, HeroButtonGroup],
  childs: [HeroTitle, HeroSubtitle, HeroButtonGroup],
};

export default Hero;
